// ── Русский ───────────────────────────────────────────────────────────────────
//
// Словарь ПУСТ, и это правильное состояние.
//
// Раньше часть подписей была написана в коде по-узбекски, а здесь лежал их
// русский перевод. Читалось это как сбой: заголовок русский, соседняя кнопка
// вдруг узбекская, а какая именно — зависело от того, попал ключ в словарь или
// нет. Теперь узбекских подписей в коде не осталось: всё переведено на месте,
// и переводить обратно нечего.
//
// Ключ в t() — это сам русский текст. Нет ключа в словаре — показывается сам
// ключ, то есть русский. Поэтому пустой словарь работает как «показывай как
// написано», и ни одна строка не теряется.
//
// Файл оставлен намеренно: когда появится узбекская и казахская версии,
// они лягут рядом (uz.js, kk.js) с ТЕМИ ЖЕ русскими ключами, а здесь останется
// пусто — русскому переводить себя не нужно. Названия кнопок при этом
// не переводятся: на экране они русские, и в руководстве названы так же.
//
// Не возвращай сюда узбекские ключи. Узбекский текст в коде интерфейса —
// это ошибка, а не «пока так»: см. CLAUDE.md, раздел «Переводы (i18n)».

export const RU = {};
